import {ReactNode} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Link, css, view} from '@sail/ui/deprecated';
import {Theme} from '@stripe-internal/conversations-ui';
import {RequestACallVerificationCodeEndpointResponseClientError} from '@stripe-internal/conversations-shared-dependencies';

export const messages = defineMessages({
  genericVerificationCodesError: {
    id: 'support_conversations_client.rac.confirmation.genericVerificationCodesError',
    description:
      'Error message when loading support verification codes telling user to refresh the page',
    defaultMessage:
      'Something went wrong. Please refresh the page to verify your phone call.',
  },
  loginErrorMessage: {
    id: 'support_conversations_client.rac.confirmation.loginVerificationCodesError',
    description: 'Error message indicating the user needs to login',
    defaultMessage: 'Please sign in to verify your phone call.',
  },
});

type Props = {
  theme: Theme;
  clientError?: RequestACallVerificationCodeEndpointResponseClientError;
  serverError?: boolean;
};

// eslint-disable-next-line @stripe-internal/stripe/no-anonymous-jsx-functions
export const renderRequestACallError = ({
  theme,
  clientError,
  serverError,
}: Props): ReactNode => {
  if (!clientError && !serverError) return null;

  let errorMessage;

  if (clientError?.type === 'unauthorized') {
    errorMessage = <FormattedMessage {...messages.loginErrorMessage} />;
  } else {
    errorMessage = (
      <FormattedMessage {...messages.genericVerificationCodesError} />
    );
  }

  if (clientError?.signInUrl) {
    return (
      <Link
        href={clientError.signInUrl}
        target="_top"
        css={{
          color: css.value(theme.linkColor),
        }}
      >
        {errorMessage}
      </Link>
    );
  } else {
    return <view.span css={{font: 'body'}}>{errorMessage}</view.span>;
  }
};
